import {
  fetchSession,
  loginWithPassword,
  logoutSession,
} from '@xstudios/xapp-auth/services/allauthSessionAuthService'
import { defineStore } from 'pinia'

export const useAllauthSessionAuthStore = defineStore('allauth-session-auth', {
  actions: {
    _clear() {
      this.user = null
      this.authenticated = false
    },

    async bootstrap() {
      if (this.bootstrapped) return
      await this.checkSession()
      this.bootstrapped = true
    },

    can() {
      return !!this.user?.is_superuser
    },

    canAll() {
      return !!this.user?.is_superuser
    },

    canAny() {
      return !!this.user?.is_superuser
    },

    async checkSession() {
      this.loading = true
      try {
        const payload = await fetchSession()
        const sessionUser = payload?.data?.user || null
        this.user = sessionUser
        this.authenticated = !!sessionUser
      } catch {
        this._clear()
      } finally {
        this.loading = false
      }
    },

    clearSession() {
      this._clear()
    },

    async login(email, password) {
      await fetchSession()
      const payload = await loginWithPassword(email, password)
      const sessionUser = payload?.data?.user || null
      this.user = sessionUser
      this.authenticated = !!sessionUser
      return payload
    },

    async logout() {
      try {
        await logoutSession()
      } finally {
        this._clear()
      }
    },
  },
  state: () => ({
    authenticated: false,
    bootstrapped: false,
    loading: false,
    token: null,
    user: null,
  }),
})
